module.exports = __webpack_public_path__ + "media/images/writer/user_extension_notification_mailer/analysis-9edf63f54ed0e2e5de09b39b9db71ab2.png";